import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import { Button, FormControlLabel, Grid, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import { get } from "lodash";

const StyledPageToolbar = styled(Grid)(() => ({
    marginBottom: "20px",
    marginTop: "20px",
}));

const StyledLeftIcon = styled(Grid)(() => ({
    marginLeft: "25px",
}));

const StyledInactiveText = styled("div")(() => ({
    fontSize: "14px",
    paddingRight: "25px",
}));

const AdminToolbar = (props) => {
    const { handleInputChange, handleSaveAccountUpdates, history, userAccount, toggleAddProxy } = props;

    const handleCancel = () => {
        history.push("/admin/users");
    };

    return (
        <StyledPageToolbar container justifyContent="space-between" alignItems="center" spacing={16}>
            <Grid item>
                <h2 className="page-title">Edit User Account</h2>
            </Grid>
            <Grid item>
                <Grid container alignItems="center" spacing={0}>
                    <Grid item>
                        {get(userAccount, "activeFlg", null) === false &&
                        get(userAccount, "inactiveDate", null) != null ? (
                            <StyledInactiveText>
                                Inactivated On: {get(userAccount, "inactiveDate", null)}
                            </StyledInactiveText>
                        ) : (
                            ""
                        )}
                    </Grid>
                    <Grid item>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={userAccount.activeFlg ? true : false}
                                    onChange={(e) => handleInputChange("userAccount.activeFlg", e.target.checked)}
                                    color="primary"
                                    disabled={false}
                                />
                            }
                            label="Active"
                        />
                    </Grid>
                    <Button
                        disabled={userAccount?.allowedProxies === undefined}
                        sx={{ color: "black" }}
                        startIcon={<GroupAddOutlinedIcon sx={{ color: "grey" }} />}
                        onClick={toggleAddProxy}
                        data-testid="proxies-toolbar-button"
                    >
                        Proxies
                    </Button>
                    <StyledLeftIcon item>
                        <Button variant="outlined" color="primary" onClick={handleCancel}>
                            Cancel
                        </Button>
                    </StyledLeftIcon>
                    <Grid item>
                        <Button color="primary" variant="contained" onClick={handleSaveAccountUpdates}>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </StyledPageToolbar>
    );
};

export default AdminToolbar;
